import styled from '@emotion/styled'

export const StyleBg = styled.span<any>`
  background: ${(props: any) => props.theme.colors[props?.bg || 'primary50']};
  color: ${(props: any) => props.theme.colors[props?.tc || 'primary']};
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 4px;
  display: block;
  text-align: center;
  width: max-content;

  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 480px) {
    font-size: 9px;
  }
`

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`

export const DropdownButton = styled.button<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 12px;
  background-color: ${(props: any) =>
    props.theme.colors[props.bg ? props.bg : 'primary50']};
  color: ${(props: any) =>
    props.theme.colors[props.tc ? props.bg : 'primaryText']};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  overflow: visible;
  min-width: 120px;
  &:focus {
    outline: none;
  }
`

export const DropdownList = styled.div<any>`
  position: absolute;
  top: ${(props: any) => (!!props.isLast ? '-120px' : '100%')};
  left: 0;
  width: 100%;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
`

export const DropdownItem = styled.div<any>`
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: ${(props: any) =>
      props.theme.colors[props.bg ? props.bg : 'primary50']};
  }
`
